var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgRedo = function SvgRedo(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.625 13.75L19 9.375M19 9.375L14.625 5M19 9.375H9.8125C8.53615 9.375 7.31207 9.88203 6.40955 10.7845C5.50703 11.6871 5 12.9111 5 14.1875C5 14.8195 5.12448 15.4453 5.36633 16.0292C5.60818 16.613 5.96267 17.1436 6.40955 17.5905C7.31207 18.493 8.53615 19 9.8125 19H12.875",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRedo);
export { ForwardRef as ReactComponent };